// Dependencies
import get from 'lodash/get';
import appConfig from '@nerdwallet/app-config';

// Local Dependencies
import * as builderActions from '../actions/action-types';
import { flatOutline as flatOutlineReducer } from '../reducers/builder';
import { buildTree } from '../../outline-manipulation';

// this middleware is the responsible for connecting LPC and WordPress,
// we grab the whole state and send it to WP via postMessage.
export default (store) => (next) => (action) => {
  if (action.type in builderActions) {
    // If we're in an iframe, we need to alert parent of new page config.
    // Precompute forthcoming state changes before posting.
    if (window && window.parent !== window) {
      const flatOutLineState = get(store.getState(), 'builder.flatOutline');
      const nextFlatOutlineState = flatOutlineReducer(flatOutLineState, action);
      const nextConfig = buildTree(nextFlatOutlineState);

      window.parent.postMessage(
        {
          landingPageData: true,
          pageConfig: JSON.stringify(nextConfig),
        },
        appConfig.SITE_BASE_URL
      );
    }
  }

  return next(action);
};
